<labeling-task-review [privilegesOnTask]="privilegesOnTask"></labeling-task-review>